/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { Pressable } from '@components/atoms/button/Pressable'
import { Icon } from '@components/atoms/icons/Icon'
import { mono, boMobile, boZ, boMotion } from './backoffice.tokens'

interface PropsType {
	onClick: () => void
	label: string
	iconName?: string
}

/** 추가 — 폰 목록의 우하단 56 원. 화면당 하나 (RESPONSIVE_PLAN §3) */
export const BoFab = (props: PropsType) => {
	const bottom = 'calc(16px + env(safe-area-inset-bottom, 0px))'

	return (
		<Pressable
			css={[style, { bottom }]}
			className="boFab"
			onClick={props.onClick}
			aria-label={props.label}
			title={props.label}
		>
			<Icon name={props.iconName ?? 'plus'} className="boFabIcon" />
		</Pressable>
	)
}

const style = css({
	position: 'fixed',
	right: 16,
	zIndex: boZ.fab,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: boMobile.fabSize,
	height: boMobile.fabSize,
	borderRadius: '50%',
	background: mono.ctaBg,
	boxShadow: '0 2px 8px rgba(22, 24, 27, 0.18)',
	transition: boMotion,
	'.boFabIcon': { fontSize: 26, color: '#FFFFFF' },
	'&:active': { background: mono.ink },
})
